//===	TEXTURE OBJECTS

export class RTexture {
    InnerTexture!: WebGLTexture;

    bLoaded = false;
}
